import classNames from "classnames";
import React, {useState} from "react";

import '../style.css'
import {useTranslation} from "react-i18next";
import Button, {BtnColor} from "../../../components/Button/Button";
import {onOrdersChangeType} from "../../../store/Orders/actions";
import {TYPE_COMPLETED, TYPE_LIVEORDERS} from "../../../store/Orders/reducer";
import {useDispatch} from "react-redux";

const ListOrders = ({ orders, onOrderClick, order, orderLoading }) => {
    const dispatch = useDispatch()
    const { t } = useTranslation()

    const [menuState, setMenuState] = useState(TYPE_LIVEORDERS)

    const menuItem1Color = menuState === TYPE_LIVEORDERS ? BtnColor.black : BtnColor.gray;
    const menuItem2Color = menuState === TYPE_COMPLETED ? BtnColor.black : BtnColor.gray;

    const setTab = (type) => {
        setMenuState(type)
        dispatch(onOrdersChangeType(type))
    }

    return (
        <div className="bg-white overflow-hidden sm:rounded-lg">

            <div className="list-orders-title text-center py-2">
                <Button onClick={() => setTab(TYPE_LIVEORDERS)} color={menuItem1Color} className="font-bold rounded-r-none">{t('Live orders')}</Button>
                <Button onClick={() => setTab(TYPE_COMPLETED)} color={menuItem2Color} className="font-bold rounded-l-none">{t('Completed')}</Button>
            </div>

            {orders.map((orderItem) => {
                let classname = classNames("item shadow sm:rounded-lg px-4 py-2 m-2 cursor-pointer", {
                    "bg-indigo-100": orderItem.id === order.id
                });
                return (
                    <div className={classname} key={orderItem.id} onClick={() => onOrderClick(orderItem.id)}>
                        <div className="flex justify-between">
                            <span className="font-bold text-indigo-600">#{orderItem.roid}</span>
                            <span className="text-sm text-indigo-600">{orderItem.status}</span>
                        </div>
                        <div className="flex justify-between pt-2">
                            <span className="">{orderItem.client.name}</span>

                            {orderItem.type === 'pickup' && orderItem.pickupAt ? (
                                <span className="font-bold">{t('Pickup at')} {orderItem.pickupAt}</span>
                            ) :null}

                            {orderItem.type === 'dinein' && orderItem.table_code ? (
                                <span className="font-bold">{t('Table')} #{orderItem.table_code}</span>
                            ) :null}

                            {orderItem.type === 'dinein' && orderItem.table_number ? (
                                <span className="font-bold">{t('Table')} #{orderItem.table_number}</span>
                            ) :null}
                        </div>
                    </div>
                )
            })}

            {!orders.length ? (
                <div className="item shadow sm:rounded-lg px-4 py-2 m-2">
                    <div className="flex justify-between">
                        <span className="font-bold">{t('No active orders')}</span>
                    </div>

                </div>
            ): null}

        </div>
    )
}

export default ListOrders
